/**
 * Catechism data — "Катехизис: Для серця і розуму!"
 * Source: https://usaregeneration.church/сatechesis-ua/
 *
 * Structure:
 *   3 parts, 52 Q&A flip-cards total
 *   Each card: question, Bible reference, Bible verse, answer, icon
 *
 * Image assets (original):
 *   Hero:    /wp-content/uploads/2025/10/fon-k-ua-1920x760-1.jpg
 *   Cards:   /wp-content/uploads/2025/10/k{NN}a.jpg (front), k{NN}b.jpg (back)
 *   Dividers: k00b.jpeg (part1), k000-1side.jpeg (part2), k0000-1side.webp (part3)
 */

const catechismData = {
  title: 'Катехизис',
  subtitle: 'Для серця і розуму!',
  heroImage: 'fon-k-ua-1920x760-1.jpg',

  parts: [
    // ─────────────────────────────────────────────
    // PART 1 — Бог, творіння, гріхопадіння і закон
    // ─────────────────────────────────────────────
    {
      id: 1,
      title: 'Бог, творіння, гріхопадіння і закон.',
      color: '#F5A623', // orange
      icon: 'cross-heart', // cross with heart inside
      questions: [
        {
          id: 1,
          question: 'Яка наша єдина надія в житті та після смерті?',
          reference: 'Рим. 14:7-8',
          verse:
            'Бо ніхто з нас не живе сам для себе, і не вмирає ніхто сам для себе. Бо коли живемо для Господа живемо, і коли вмираємо для Господа вмираємо. І чи живемо, чи вмираємо ми Господні!',
          answer:
            'Те, що ми належимо не собі, але повністю духом, душею та тілом, в житті та смерті - Богові та нашому Спасителю Ісусу Христу.',
        },
        {
          id: 2,
          question: 'Хто такий Бог?',
          reference: 'Пс. 85:8-10,15',
          verse:
            'Нема, Господи, поміж богами такого, як Ти, і чинів нема, як чини Твої! Всі народи, яких Ти створив, поприходять і попадають перед лицем Твоїм, Господи, та ім\'я Твоє славити будуть, великий бо Ти, та чуда вчиняєш, Ти Бог єдиний! А Ти, Господи, Бог щедрий і милосердний, довготерпеливий і многомилостивий, і справедливий…',
          answer:
            'Бог - Творець і центр життя всього і кожного. Він Вічний, Нескінченний і Всемогутній, Незмінний у Своїй силі і досконалості, доброті і славі, мудрості, справедливості і правді. Нічого не відбувається без Нього і без Його волі.',
        },
        {
          id: 3,
          question: 'Скільки осіб у Бозі?',
          reference: '2 Кор. 13:13',
          verse:
            'Благодать Господа нашого Ісуса Христа, і любов Бога й Отця, і причастя Святого Духа нехай буде зо всіма вами!',
          answer:
            'Є три особи в єдиному правдивому та живому Бозі: Отець, Син та Дух Святий. Вони однакові за своєю сутністю, рівні в силі та славі.',
        },
        {
          id: 4,
          question: 'Як і чому нас створив Бог?',
          reference: 'Бут. 1:27',
          verse:
            'І Бог на Свій образ людину створив, на образ Божий її Він створив, як чоловіка та жінку створив їх.',
          answer:
            'Бог створив нас чоловіком та жінкою за Своїм образом, щоб ми знали Його, любили Його, жили з Ним та прославляли Його. Тому нам, створеним Богом, потрібно жити для Його слави.',
        },
        {
          id: 5,
          question: 'Що ще було створено Богом?',
          reference: 'Бут. 1:31',
          verse: 'І побачив Бог усе, що вчинив. І ото, вельми добре воно!',
          answer:
            'Бог створив усе Своїм могутнім Словом і все Його творіння було чудовим. Все процвітає під Його люблячим правлінням.',
        },
        {
          id: 6,
          question: 'Як ми можемо прославити Бога?',
          reference: 'Повтор. 11:1',
          verse:
            'І будеш ти любити Господа, Бога свого, і будеш додержувати постанови Його, і звичаї Його і закони Його, і заповіді Його по всі дні.',
          answer:
            'Ми прославляємо Бога насолоджуючись Ним, люблячи Його, довіряючи Йому і підкорюючись Його волі, заповідям та закону.',
        },
        {
          id: 7,
          question: 'Що вимагає Божий Закон?',
          reference: 'Матф. 22:37-40',
          verse:
            'Він же промовив йому: Люби Господа Бога свого всім серцем своїм, і всією душею своєю, і всією своєю думкою. Це найбільша й найперша заповідь. А друга однакова з нею: Люби свого ближнього, як самого себе. На двох оцих заповідях увесь Закон і Пророки стоять.',
          answer:
            'Особистої, досконалої та постійної слухняності; щоб ми любили Бога всім своїм сердцем, душею, розумом та силою, і ближнього свого, як самого себе. Усупереч Божим заборонам ніколи не можна чинити. Те, що Бог повеліває, потрібно робити завжди.',
        },
        {
          id: 8,
          question: 'Що Божий закон говорить у Десятьох Заповідях?',
          reference: 'Вих. 20:3',
          verse: 'Хай не буде тобі інших богів передо Мною!',
          answer:
            'Хай не буде тобі інших богів передо Мною! Не роби собі різьби і всякої подоби з того, що на небі, і що на землі долі і що в воді під землею, - не вклоняйся їм і не служи їм. Не призивай Іменя Господа, Бога твого, надаремно. Пам\'ятай день суботній, щоб святити його! Шануй свого батька та матір свою. Не вбивай! Не чини перелюбу! Не кради! Не свідкуй неправдиво на ближнього свого! Не жадай чужого.',
        },
        {
          id: 9,
          question:
            'Що Бог вимагає в першій, другій і третій заповідях?',
          reference: 'Повтор. 6:13-14',
          verse:
            'Бійся Господа, Бога свого, і Йому будеш служити, і Йменням Його будеш присягати.',
          answer:
            'По-перше, щоб ми знали Бога, довіряли Йому, як єдиному правдивому і живому Богу. По-друге, щоб ми уникали будь-якого ідолопоклонства і поклонялись Богу належним чином. По-третє, щоб ми ставились до Божого Імені зі страхом та благоговінням, шануючи Його Слово і діла.',
        },
        {
          id: 10,
          question:
            'Що Бог вимагає в четвертій та п\'ятій заповідях?',
          reference: 'Вих. 20:11-12',
          verse:
            'Бо шість день творив Господь небо та землю, море та все, що в них, а дня сьомого спочив тому поблагословив Господь день суботній і освятив його. Шануй свого батька та матір свою, щоб довгі були твої дні на землі, яку Господь, Бог твій, дає тобі!',
          answer:
            'Четверта заповідь повеліває, щоб ми проводили день відпочинку у спільному та особистому поклонінню Богу: відпочивали від щоденних справ, служили Господу та ближнім, таким чином очікуючи вічного спокою з Богом. П\'ята заповідь велить, щоб ми любили та поважали батьків, підкоряючись їхнім побожним настановам та вихованню.',
        },
        {
          id: 11,
          question: 'Що Бог вимагає в 6, 7 та 8 заповідях?',
          reference: 'Рим. 13:9',
          verse:
            'Не чини перелюбу, Не вбивай, Не кради, Не свідкуй неправдиво, Не пожадай й які інші, вони містяться всі в цьому слові: Люби свого ближнього, як самого себе!',
          answer:
            'Шоста проголошує, щоб ми не завдавали болю ближньому і не ставились до нього з ненавистю або ворожнечею, але були терпеливими і миролюбними, прагнучи любити навіть ворогів. Сьома каже, щоб ми не були сексуально розпущеними, жили чисто та вірно у шлюбі чи в самотності, уникаючи всіх нечистих вчинків, вигляду, слів, думок або бажань і будь-чого, що могло б сприяти їм. Восьма - щоб ми не брали без дозволу того, що належить іншому, та не відмовляли в добрі тим, кому можемо допомогти.',
        },
        {
          id: 12,
          question:
            'Що Бог вимагає в дев\'ятій та десятій заповідях?',
          reference: 'Як. 2:8',
          verse:
            'Коли ви Закона Царського виконуєте, за Писанням: Люби свого ближнього, як самого себе, то ви робите добре',
          answer:
            'Дев\'ята проголошує, щоб ми не говорили неправду і не вводили в оману, але говорили правду з любов\'ю. Десята - щоб ми були задоволені, і не заздрили та не обурювались за те, що було дано Богом нам або іншим.',
        },
        {
          id: 13,
          question: 'Чи може хтось досконало виконати Божий Закон?',
          reference: 'Рим. 3:10-12',
          verse:
            'Нема праведного ані одного; нема, хто розумів би; немає, хто Бога шукав би, усі повідступали, разом стали непотрібні, нема доброчинця, нема ні одного!',
          answer:
            'З моменту гріхопадіння жодна людина не в змозі виконати закон Божий бездоганно, але постійно порушує його думкою, словом чи ділом.',
        },
        {
          id: 14,
          question:
            'Чи створив нас Бог нездатними виконати Його закон?',
          reference: 'Рим. 5:12',
          verse:
            'Тому то, як через одного чоловіка ввійшов до світу гріх, а гріхом смерть, так прийшла й смерть у всіх людей через те, що всі згрішили.',
          answer:
            'Ні, але через непослух наших прабатьків Адама і Еви все творіння впало у гріх і усі ми народжуємось грішниками, винуватими, зіпсутими у нашій природі, нездатні виконати Божий закон!',
        },
        {
          id: 15,
          question:
            'Якщо ніхто не здатен виконати Божий закон, то для чого він потрібен?',
          reference: 'Рим. 3:20',
          verse:
            'Бо жадне тіло ділами Закону не виправдається перед Ним, Законом бо гріх пізнається.',
          answer:
            'Щоб ми пізнали святу Божу природу і волю, а також гріховну природу та непокору наших сердець, що означає, що ми потребуємо Спасителя. Закон Божий також навчає і закликає нас прожити життя гідне нашого Спасителя.',
        },
        {
          id: 16,
          question: 'Що таке гріх?',
          reference: '1 Ів. 3:4',
          verse:
            'Кожен, хто чинить гріх, чинить і беззаконня. Бо гріх то беззаконня.',
          answer:
            'Гріх - це відкидання або ігнорування Бога у світі, який Він створив. Це бунт проти Бога, коли ми не рахуємось із Ним і не виконуємо вимог Його закону у тому, ким ми є, і що робимо. Цей бунт приводить до нашої смерті та руйнування усього творіння.',
        },
        {
          id: 17,
          question: 'Що таке ідолопоклонство?',
          reference: 'Рим. 1:21,25',
          verse:
            '...бо, пізнавши Бога, не прославляли Його, як Бога, і не дякували, але знікчемніли своїми думками, і запаморочилось нерозумне їхнє серце... Вони Божу правду замінили на неправду, і честь віддавали, і служили створінню більш, як Творцеві...',
          answer:
            'Ідолопоклонство - це надія на створені речі більше, ніж на Творця, з метою віднайти щастя, сенс життя та безпеку.',
        },
        {
          id: 18,
          question:
            'Чи залишить Бог наш непослух та ідолопоклонство без покарання?',
          reference: 'Еф. 5:5-6',
          verse:
            'Знайте бо це, що жаден розпусник, чи нечистий, або зажерливий, що він ідолянин, не має спадку в Христовому й Божому Царстві! Нехай вас не зводить ніхто словами марнотними, бо гнів Божий приходить за них на неслухняних...',
          answer:
            'Ні, кожен гріх - це повстання проти суверенності, святості і доброти Бога, проти Його справедливого закону. Бог праведно гнівається за наші гріхи і покарає за них під час Свого справедливого суду як у цьому житті, так і в майбутньому.',
        },
        {
          id: 19,
          question:
            'Чи існує який-небудь спосіб уникнути покарання і повернутися у стан, котрий Богу до вподоби?',
          reference: 'Іс. 53:10-11',
          verse:
            'Та зволив Господь, щоб побити Його, щоб муки завдано Йому. Якщо ж душу Свою покладе Він як жертву за гріх, то побачить насіння, і житиме довгії дні, і замір Господній рукою Його буде мати поводження! Він через муки Своєї душі буде бачити плід, та й насититься. Справедливий, Мій Отрок, оправдає пізнанням Своїм багатьох, і їхні гріхи понесе',
          answer:
            'Так. Щоб задовольнити Свою справедливість, Сам Бог тільки по Своїй милості примиряє нас із Собою через Відкупителя і звільняє нас від гріха і від покарання за гріх.',
        },
        {
          id: 20,
          question: 'Хто такий Відкупитель?',
          reference: '1 Тим. 2:5',
          verse:
            'Один бо є Бог, і один Посередник між Богом та людьми, людина Христос Ісус.',
          answer:
            'Єдиний Відкупитель - це Господь Ісус Христос, вічний Божий Син, в Якому Бог став людиною та поніс покарання за гріх.',
        },
      ],
    },

    // ─────────────────────────────────────────────
    // PART 2 — Христос, викуплення, благодать
    // ─────────────────────────────────────────────
    {
      id: 2,
      title: 'Христос, викуплення, благодать.',
      color: '#2E7BBF', // blue
      icon: 'person-silhouette', // silhouette in frame
      questions: [
        {
          id: 21,
          question:
            'Який Відкупитель нам потрібен, щоб повернути нас назад до Бога?',
          reference: 'Іс. 9:6',
          verse:
            'Бо Дитя народилося нам, даний нам Син, і влада на раменах Його, і кликнуть ім\'я Йому: Дивний Порадник, Бог сильний, Отець вічности, Князь миру.',
          answer:
            'Нам потрібен Той, Хто справжня людина і справжній Бог.',
        },
        {
          id: 22,
          question: 'Чому Відкупитель має бути людиною?',
          reference: 'Євр. 2:17',
          verse:
            'Тому мусив бути Він у всьому подібний братам, щоб стати милостивим та вірним Первосвящеником у Божих справах, для вблагання за гріхи людей.',
          answer:
            'Тому що в людському тілі Він зміг замість нас досконало виконати весь Закон і понести покарання за наші гріхи. Також Він може співчувати нашим слабостям.',
        },
        {
          id: 23,
          question: 'Чому Відкупитель повинен бути Богом?',
          reference: 'Дії 2:24',
          verse:
            'Та Бог воскресив Його, пута смерти усунувши, вона бо тримати Його не могла',
          answer:
            'Тому що, завдяки Його божественній природі, Його слухняність і страждання були досконалі та ефективні. Таким чином, Він був здатним витримати тягар праведного Божого гніву за гріх та подолати смерть.',
        },
        {
          id: 24,
          question: 'Чому Христос, Відкупитель, мав померти?',
          reference: 'Кол. 1:21-22',
          verse:
            'І вас, що були колись відчужені й вороги думкою в злих учинках, тепер же примирив смертю в людськім тілі Його, щоб учинити вас святими, і непорочними, і неповинними перед Собою.',
          answer:
            'Смерть - це відплата за гріх. Христос сам добровільно помер замість нас, щоб визволити усіх від влади гріха і покарання за гріх та щоб повернути нас до Бога. Своєю заступницькою викупною смертю Він один рятує нас від пекла і дає прощення гріхів, праведність та вічне життя.',
        },
        {
          id: 25,
          question:
            'Чи Христова смерть означає, що всі наші гріхи можуть бути прощені?',
          reference: '2 Кор. 5:21',
          verse:
            'Бо Того, Хто не відав гріха, Він учинив за нас гріхом, щоб стали ми Божою правдою в Нім!',
          answer:
            'Так, Христова смерть на хресті повністю оплатила покарання за наш гріх. Бог милостиво зараховує нам Христову праведність, як ніби вона є наша власна, і більше не згадає наших гріхів.',
        },
        {
          id: 26,
          question: 'Що ще відкупляє Христова смерть?',
          reference: 'Кол. 1:19-20',
          verse:
            'Бо вгодно було, щоб у Нім перебувала вся повнота, і щоб Ним поєднати з Собою все, примиривши кров\'ю хреста Його, через Нього, чи то земне, чи то небесне.',
          answer:
            'Христова смерть - це початок відкуплення і відновлення зіпсутого гріхом творіння, яким Він потужно керує заради Своєї слави та для добра самого творіння.',
        },
        {
          id: 27,
          question:
            'Чи усі люди, втрачені через Адама, будуть спасенні через Христа?',
          reference: 'Рим. 5:17',
          verse:
            'Бо коли за переступ одного смерть панувала через одного, то тим більше ті, хто приймає рясноту благодаті й дар праведности, запанують у житті через одного Ісуса Христа.',
          answer:
            'Жертви Христа достатньо для того, щоб спасти усіх, але спасаються ті, хто поєднаний з Христом через особисту віру у Нього, як результат вибрання та Божої милості. Бог, по Своїй любові, виявляє загальну благодать до усіх, стримуючи наслідки гріха та створюючи умови для культурної діяльності та добробуту.',
        },
        {
          id: 28,
          question:
            'Що відбувається після смерті з тими, хто не поєднаний з Христом через віру?',
          reference: 'Ів. 3:16-18,36',
          verse:
            'Так бо Бог полюбив світ, що дав Сина Свого Однородженого, щоб кожен, хто вірує в Нього, не згинув, але мав життя вічне. Бо Бог не послав Свого Сина на світ, щоб Він світ засудив, але щоб через Нього світ спасся. Хто вірує в Нього, не буде засуджений; хто ж не вірує, той вже засуджений, що не повірив в Ім\'я Однородженого Сина Божого. Хто вірує в Сина, той має вічне життя; а хто в Сина не вірує, той життя не побачить а гнів Божий на нім перебуває.',
          answer:
            'У день Суду вони отримають страшний, але справедливий вирок. Вони будуть навіки вигнані з Божої благодатної присутності у пекло, щоб понести справедливе покарання в муках.',
        },
        {
          id: 29,
          question: 'Як нам спастись?',
          reference: 'Еф. 2:8-9',
          verse:
            'Бо спасені ви благодаттю через віру, а це не від вас, то дар Божий, не від діл, щоб ніхто не хвалився.',
          answer:
            'Тільки через віру в Ісуса Христа та в Його замісну та викупну смерть на хресті. Таким чином, хоч ми і винуваті в неслухняності Богу і все ще схильні до зла, Бог, без будь-яких наших заслуг, але виключно по Своїй благодаті, зараховує нам досконалу праведність Христа, коли ми каємось та віруємо у Нього.',
        },
        {
          id: 30,
          question: 'Що означає вірити в Ісуса Христа?',
          reference: 'Гал. 2:20',
          verse:
            'І живу вже не я, а Христос проживає в мені. А що я живу в тілі тепер, живу вірою в Божого Сина, що мене полюбив, і видав за мене Самого Себе.',
          answer:
            'Вірити в Ісуса Христа — це визнати, що все, що Бог відкриває у Своєму Слові - правда. Довіряти Йому, приймати Христа таким, яким Він представлений в Писанні та повністю покладатись у спасінні лише на Нього.',
        },
        {
          id: 31,
          question: 'У що конкретно ми віримо?',
          reference: 'Юди 1:3',
          verse:
            '...я признав за потрібне писати до вас, благаючи боротись за віру, раз дану святим',
          answer:
            'Ми віримо усьому, чому навчає Євангелія. Апостольський символ віри говорить: Вірую в Бога Отця Всемогутнього, Творця неба і землі. І в Ісуса Христа, Його Єдинородного Сина, Господа нашого, що був зачатий від Духа Святого, народився від Діви Марії, що страждав за Понтія Пилата, був розп\'ятий, і помер, і був похований, зійшов до ада. Третього дня воскрес із мертвих, вознісся на небеса, і сидить праворуч Бога Отця Всемогутнього. Звідти прийде судити живих і мертвих. Вірую в Духа Святого; святу Вселенську Церкву; спілкування святих; відпущення гріхів; воскресіння з мертвих і вічне життя.',
        },
        {
          id: 32,
          question: 'Що означає "виправдання" і "освячення"?',
          reference: '1 Кор. 6:11',
          verse:
            '...але ви обмились, але освятились, але виправдались Іменем Господа Ісуса Христа й Духом нашого Бога.',
          answer:
            'Виправдання - це проголошена праведність перед Богом, яка нам зарахована завдяки смерті Христа і Його воскресінню за нас. Освячення - це наш поступовий зріст у праведності завдяки праці Духа Святого в нас.',
        },
        {
          id: 33,
          question:
            'Чи повинні ті, хто вірує в Христа, намагатися спастись своїми власними справами або чимось ще?',
          reference: 'Гал. 2:16',
          verse:
            'А коли ми дізнались, що людина не може бути виправдана ділами Закону, але тільки вірою в Христа Ісуса, то ми ввірували в Христа Ісуса, щоб нам виправдатися вірою в Христа, а не ділами Закону. Бо жадна людина ділами Закону не буде виправдана.',
          answer:
            'Ні, не повинні, оскільки у Христі є все необхідне для нашого спасіння. Намагання спастися добрими справами означає заперечення того, що Христос - це єдиний Відкупитель і Спаситель.',
        },
        {
          id: 34,
          question:
            'Оскільки ми викуплені тільки по благодаті і тільки Христом, чи маємо ми робити добрі вчинки і коритись Біблії?',
          reference: '1 Петра 2:11-12',
          verse:
            'Благаю вас, любі, як приходьків та подорожніх, щоб ви здержувались від тілесних пожадливостей, що воюють проти душі. Поводьтеся поміж поганами добре, щоб за те, за що вас обмовляють вони, немов би злочинців, побачивши добрі діла, славили Бога в день відвідання',
          answer:
            'Так, тому що Христос, викупивши нас Своєю кров\'ю, оновлює нас Своїм Духом. Потрібно робити добрі вчинки, щоб своїм життям виявити любов і вдячність Богу; щоб ми могли бути впевнені у щирості своєї віри, бачачи її плоди; щоб інші пізнали Христа через наше благочестиве поводження.',
        },
        {
          id: 35,
          question:
            'Якщо ми викуплені тільки благодаттю і тільки через віру, звідки у нас віра?',
          reference: 'Тит. 3:4-6',
          verse:
            'Він нас спас не з діл праведности, що ми їх учинили були, а з Своєї милости через купіль відродження й обновлення Духом Святим, Якого Він щедро вилив на нас через Христа Ісуса, Спасителя нашого...',
          answer:
            'Віру, як і всі дари, Христос дає нам через Святого Духа. Він робить це через читання і слухання Слова Божого.',
        },
      ],
    },

    // ─────────────────────────────────────────────
    // PART 3 — Святий Дух, відродження і зріст у благодаті
    // ─────────────────────────────────────────────
    {
      id: 3,
      title: 'Святий Дух, відродження і зріст у благодаті.',
      color: '#2E9B4E', // green
      icon: 'flame', // flame in frame
      questions: [
        {
          id: 36,
          question: 'У що ми віримо стосовно Святого Духа?',
          reference: 'Ів. 14:16-17',
          verse:
            'І вблагаю Отця Я, і Втішителя іншого дасть вам, щоб із вами повік перебував, Духа правди, що Його світ прийняти не може, бо не бачить Його та не знає Його. Його знаєте ви, бо при вас перебуває, і в вас буде Він.',
          answer:
            'Разом з Отцем та Сином Дух Святий - вічний Бог. Духа Святого Бог дає навічно усім віруючим.',
        },
        {
          id: 37,
          question: 'Як Святий Дух допомагає нам?',
          reference: 'Еф. 6:17-18',
          verse:
            'Усякою молитвою й благанням кожного часу моліться духом, а для того пильнуйте з повною витривалістю та молитвою за всіх святих...',
          answer:
            'Святий Дух докоряє нас в наших гріхах, спонукає до покаяння, відроджує до нового життя, потішає, веде, дає духовні дари та бажання слухатися Бога. Він робить нас здатними молитися і розуміти Боже Слово.',
        },
        {
          id: 38,
          question: 'Що таке молитва?',
          reference: 'Пс. 61:8-9',
          verse:
            'Мій народе, кожного часу надійтесь на Нього, серце своє перед Ним виливайте, Бог для нас пристановище',
          answer:
            'Молитва - це відкриття нашого серця перед Богом у хвалі, заступництві, проханні, сповіданні гріха та подяці.',
        },
        {
          id: 39,
          question: 'З яким ставленням потрібно молитись?',
          reference: 'Філ. 4:6',
          verse:
            'Ні про що не турбуйтесь, а в усьому нехай виявляються Богові ваші бажання молитвою й проханням з подякою.',
          answer:
            'З любов\'ю, наполегливістю та вдячністю, смиренно покоряючись Божій волі і знаючи, що заради Христа Він завжди чує наші молитви.',
        },
        {
          id: 40,
          question: 'Про що ми маємо молитися?',
          reference: '1 Тим 2:1-2',
          verse:
            'Отже, перш над усе я благаю чинити молитви, благання, прохання, подяки за всіх людей, за царів та за всіх, хто при владі, щоб могли ми провадити тихе й мирне життя в усякій побожності та чистості.',
          answer:
            'Все Слово Боже спрямовує нас на те, про що молитись і надихає молитися, включаючи молитву, якої навчав сам Ісус.',
        },
        {
          id: 41,
          question: 'Що таке Господня молитва?',
          reference: 'Мтф. 6:9-13',
          verse:
            '«Отче наш, що єси на небесах! Нехай святиться Ім\'я Твоє, нехай прийде Царство Твоє, нехай буде воля Твоя, як на небі, так і на землі. Хліба нашого насущного дай нам сьогодні. І прости нам довги наші, як і ми прощаємо винуватцям нашим. І не введи нас у випробовування, але визволи нас від лукавого. Бо Твоє є царство, і сила, і слава навіки. Амінь.»',
          answer:
            '«Отче наш, що єси на небесах! Нехай святиться Ім\'я Твоє, нехай прийде Царство Твоє, нехай буде воля Твоя, як на небі, так і на землі. Хліба нашого насущного дай нам сьогодні. І прости нам довги наші, як і ми прощаємо винуватцям нашим. І не введи нас у випробовування, але визволи нас від лукавого. Бо Твоє є царство, і сила, і слава навіки. Амінь.»',
        },
        {
          id: 42,
          question: 'Як потрібно читати і слухати Слово Боже?',
          reference: '2 Тим. 3:16-17',
          verse:
            'Усе Писання Богом надхнене, і корисне до навчання, до докору, до направи, до виховання в праведності, щоб Божа людина була досконала, до всякого доброго діла готова.',
          answer:
            'Щоденно, зі старанням, готовністю слухати та молитвою; щоб ми могли прийняти Його з вірою, зберігати Його у наших серцях і застосовувати у нашому житті.',
        },
        {
          id: 43,
          question: 'Що таке «таїнства»?',
          reference: 'Рим. 6:4',
          verse:
            'Отож, ми поховані з Ним хрищенням у смерть, щоб, як воскрес Христос із мертвих славою Отця, так щоб і ми стали ходити в обновленні життя.',
          footnote: 'Священнодія, заповідь Господня',
          answer:
            'Таїнства дані Богом і започатковані Христом, а саме: хрещення та Господня Вечеря. Вони є видимими знаками та печаттю того, що ми пов\'язані разом, як спільнота віруючих в Ісуса, через Його смерть і воскресіння. Коли ми приймаємо в них участь, Святий Дух більш повно проголошує та запечатує в нас обітниці Євангелії.',
        },
        {
          id: 44,
          question: 'Що таке «хрещення»?',
          reference: 'Мтф. 28:19',
          verse:
            'Тож ідіть, і навчіть всі народи, христячи їх в Ім\'я Отця, і Сина, і Святого Духа...',
          answer:
            'Хрещення — це виконання волі Божої через занурення у воду в ім\'я Отця, і Сина, і Святого Духа. Воно ознаменовує та запечатує наше усиновлення в Христі, наше очищення від гріха, нашу посвяту та належність Господу та Його церкві.',
        },
        {
          id: 45,
          question: 'Чи очищає хрещення водою від самого гріха?',
          reference: '1 Ів. 1:7',
          verse:
            'Коли ж ходимо в світлі, як Сам Він у світлі, то маємо спільність один із одним, і кров Ісуса Христа, Його Сина, очищує нас від усякого гріха.',
          answer:
            'Ні, від гріха нас очищає тільки кров Христа і оновлення Святим Духом.',
        },
        {
          id: 46,
          question: 'Що таке Господня Вечеря?',
          reference: '1 Кор. 11:23-26',
          verse:
            'Бо прийняв я від Господа, що й вам передав, що Господь Ісус ночі тієї, як виданий був, узяв хліб, подяку віддав, і переломив, і сказав: Прийміть, споживайте, це тіло Моє, що за вас ломається. Це робіть на спомин про Мене! Так само і чашу взяв Він по Вечері й сказав: Ця чаша Новий Заповіт у Моїй крові. Це робіть, коли тільки будете пити, на спомин про Мене! Бо кожного разу, як будете їсти цей хліб та чашу що пити, смерть Господню звіщаєте, аж доки Він прийде.',
          answer:
            'Христос наказав усім християнам їсти хліб і пити з чаші з вдячністю пригадуючи Його самого і Його смерть. Вечеря Господня є святкуванням Божої присутності серед нас; залученням нас до спілкування з Богом і один з одним; насиченням та підживленням наших душ. Вечеря Господня - це передчуття того дня, коли ми будемо їсти та пити з Христом у Царстві Отця.',
        },
        {
          id: 47,
          question:
            'Чи додає щось Господня Вечеря до викупного подвигу Христа?',
          reference: '1 Петр. 3:18',
          verse:
            'Бо й Христос один раз постраждав був за наші гріхи, щоб привести нас до Бога, Праведний за неправедних...',
          answer:
            'Ні, Христос один раз помер за всіх. Вечеря Господня — це заповідь, що знаменує Христовий викупний подвиг. Вона також є засобом зміцнення нашої віри, коли ми споглядаємо на Нього з передчуттям майбутнього свята в царстві Бога. Але ті, хто беруть участь у Господній вечері з непідготовленим серцем, - їдять і п\'ють в осуд для себе.',
        },
        {
          id: 48,
          question: 'Що таке церква?',
          reference: '2 Сол. 2:13',
          verse:
            'А ми завжди повинні дякувати Богові за вас, улюблені Господом браття, що Бог вибрав вас спочатку на спасіння освяченням Духа та вірою в правду,...',
          answer:
            'Бог обирає і зберігає для Себе спільноту людей, обраних для вічного життя і об\'єднаних вірою, котрі люблять Бога, слідують за Ним, навчаються у Нього і поклоняються Богові разом. Бог посилає церкву проповідувати Євангелію та своїм спільним життям і любов\'ю один до одного бути прообразом Христового Царства.',
        },
        {
          id: 49,
          question: 'Де зараз знаходиться Христос?',
          reference: 'Еф. 1:20-21',
          verse:
            '...воскресивши із мертвих Його, і посадивши на небі праворуч Себе, вище від усякого уряду, і влади, і сили, і панування, і всякого ймення, що назване не тільки в цім віці, але й у майбутньому.',
          answer:
            'Христос тілесно воскрес з могили на третій день після Своєї смерті, вознісся і сидить праворуч Отця. Зараз Христос керує Своїм Царством і заступається за нас до того часу, доки не повернеться, щоб судити та обновити весь світ.',
        },
        {
          id: 50,
          question: 'Що означає воскресіння Христа для нас?',
          reference: '1 Сол. 4:13-14',
          verse:
            'Не хочу ж я, браття, щоб не відали ви про покійних, щоб ви не сумували, як і інші, що надії не мають. Коли бо ми віруємо, що Ісус був умер і воскрес, так і покійних через Ісуса приведе Бог із Ним.',
          answer:
            'Христос переміг гріх і смерть Своїм фізичним воскресінням, щоб усі, хто вірить у Нього, теж воскресли до нового життя в цьому світі та до вічного життя у майбутньому світі. Одного разу ми воскреснемо, також буде відновлений цей світ. Але ті, хто не довіряли Христу, воскреснуть для вічної смерті.',
        },
        {
          id: 51,
          question:
            'Яка користь у тому, що Христос вознісся на небо?',
          reference: 'Рим. 8:34',
          verse:
            'Хто ж той, що засуджує? Христос Ісус є Той, що вмер, надто й воскрес, Він праворуч Бога, і Він і заступається за нас.',
          answer:
            'Христос фізично вознісся на небо заради нашої користі, так само, як і раніше Він прийшов на Землю заради нас. Він заступається за нас перед Своїм Батьком, готує для нас місце, а також дає для нас Святого Духа.',
        },
        {
          id: 52,
          question: 'У чому наша надія вічного життя?',
          reference: 'Об\'явл. 21:1-4',
          verse:
            'І бачив я небо нове й нову землю, перше бо небо та перша земля проминули, і моря вже не було. І я, Іван, бачив місто святе, Новий Єрусалим, що сходив із неба від Бога, що був приготований, як невіста, прикрашена для чоловіка свого. І почув я гучний голос із престолу, який кликав: Оце оселя Бога з людьми, і Він житиме з ними! Вони будуть народом Його, і Сам Бог буде з ними, і Бог кожну сльозу з очей їхніх зітре, і не буде вже смерти. Ані смутку, ані крику, ані болю вже не буде, бо перше минулося!',
          answer:
            'Це нагадує нам про те, що сучасний грішний світ — це ще не кінець. Незабаром ми будемо жити вічно разом із Богом, будемо насолоджуватися Ним у новому місті, в нових небесах та на новій землі. Там панує повна та вічна свобода від усякого гріха. Ми будемо жити там в оновлених, воскреслих тілах та серед нового, відновленого творіння.',
        },
      ],
    },
  ],

  // Original image URLs for reference
  images: {
    hero: 'https://usaregeneration.church/wp-content/uploads/2025/10/fon-k-ua-1920x760-1.jpg',
    part1Divider:
      'https://usaregeneration.church/wp-content/uploads/2025/10/k00b.jpeg',
    part2Divider:
      'https://usaregeneration.church/wp-content/uploads/2025/10/k000-1side.jpeg',
    part3Divider:
      'https://usaregeneration.church/wp-content/uploads/2025/10/k0000-1side.webp',
    cardBaseUrl:
      'https://usaregeneration.church/wp-content/uploads/2025/10/',
  },
};

export default catechismData;
